/* Marketing-panel imagery for the auth pages (ported from the v2 demo).
   Consented stock portraits — purely decorative social proof. */

const F = (g: "men" | "women", n: number) => `https://randomuser.me/api/portraits/${g}/${n}.jpg`;

export const FACES: string[] = [
  F("men", 32), F("women", 44), F("men", 75), F("women", 68), F("men", 11),
  F("women", 21), F("men", 54), F("women", 33), F("men", 86), F("women", 90),
  F("men", 4), F("women", 12), F("men", 41), F("women", 79), F("men", 60),
  F("women", 5), F("men", 97), F("women", 57), F("men", 23), F("women", 65),
];

export const SOCIAL_PROOF_NAMES = [
  "Aarav Mehta",
  "Sofia Almeida",
  "Daniel Cho",
  "Priya Nair",
  "Marcus Webb",
];
